import(/* webpackMode: "eager" */ "/codebuild/output/src739987009/src/pixelated-tech/apps/informationfocus/src/app/global-error.tsx");
